import { graphql } from "gatsby";
import { ToastsBasic } from "../../../../src/examples/components/Toasts";
import * as React from 'react';
export default {
  graphql,
  ToastsBasic,
  React
};